import Client from "./Typesense/Client";
import SearchClient from "./Typesense/SearchClient";
import * as Errors from "./Typesense/Errors";

export { Client, SearchClient, Errors };
export default { Client, SearchClient, Errors };

export type * from "./Typesense/Aliases";
export type * from "./Typesense/AnalyticsRulesV1";
export type * from "./Typesense/AnalyticsRuleV1";
export type * from "./Typesense/AnalyticsEvent";
export type * from "./Typesense/AnalyticsRule";
export type * from "./Typesense/AnalyticsRules";
export type * from "./Typesense/Collection";
export type * from "./Typesense/Collections";
export type * from "./Typesense/Configuration";
export type * from "./Typesense/Conversations";
export type * from "./Typesense/Conversation";
export type * from "./Typesense/ConversationModel";
export type * from "./Typesense/Debug";
export type * from "./Typesense/Documents";
export type * from "./Typesense/Health";
export type * from "./Typesense/Key";
export type * from "./Typesense/Keys";
export type * from "./Typesense/Metrics";
export type * from "./Typesense/MultiSearch";
export type * from "./Typesense/Override";
export type * from "./Typesense/Overrides";
export type * from "./Typesense/Preset";
export type * from "./Typesense/Presets";
export type * from "./Typesense/Stats";
export type * from "./Typesense/Stopword";
export type * from "./Typesense/Stopwords";
export type * from "./Typesense/Synonym";
export type * from "./Typesense/Synonyms";
export type * from "./Typesense/SynonymSet";
export type * from "./Typesense/SynonymSets";
export type * from "./Typesense/SynonymSetItem";
export type * from "./Typesense/SynonymSetItems";
export type * from "./Typesense/CurationSet";
export type * from "./Typesense/CurationSets";
export type * from "./Typesense/CurationSetItem";
export type * from "./Typesense/CurationSetItems";
